import { put, call, takeLatest } from "@redux-saga/core/effects";
import { createNewPushNotificationApi, deletePushNotificationApi, editPushNotificationApi, notificationListApi } from "../Api/api";
import { createNewPushNotificationFail, createNewPushNotificationLoad, createNewPushNotificationSuccess, deletePushNotificationLoad, editPushNotificationLoad, notificationListFail, notificationListLoad, notificationListSuccess } from "../slices/notification.slice";
import { toast } from "react-toastify";

function* notificationListSaga(action) {
    try {
        const data = yield call(notificationListApi, action.payload);
        if (data.status === 0) {
            yield put(notificationListSuccess(data.result.data));
        } else {
            yield put(notificationListFail());
        }
    } catch (e) {
        console.error("Inner circle saga error:", e);
        yield put(notificationListFail());
    }
}

function* createNewPushNotificationSaga(action) {
    try {
        const data = yield call(createNewPushNotificationApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message)
            yield put(createNewPushNotificationSuccess(data.result.data));
        } else {
            toast.error(data?.result?.message)
            yield put(createNewPushNotificationFail());
        }
    } catch (e) {
        toast.error(e)
        yield put(createNewPushNotificationFail());
    }
}

function* editPushNotificationSaga(action) {
    try {
        const data = yield call(editPushNotificationApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message)
            yield put(createNewPushNotificationSuccess(data.result.data));
        } else {
            toast.error(data?.result?.message)
            yield put(createNewPushNotificationFail());
        }
    } catch (e) {
        toast.error(e)
        yield put(createNewPushNotificationFail());
    }
}

function* deletePushNotificationSaga(action) {
    try {
        const data = yield call(deletePushNotificationApi, action.payload);
        if (data.status === 0) {
            toast.success(data?.result?.message)
            yield put(createNewPushNotificationSuccess(data.result.data));
        } else {
            toast.error(data?.result?.message)
            yield put(createNewPushNotificationFail());
        }
    } catch (e) {
        toast.error(e)
        yield put(createNewPushNotificationFail());
    }
}

export default function* rootNotificationSaga() {
    yield takeLatest(notificationListLoad.type, notificationListSaga);
    yield takeLatest(createNewPushNotificationLoad.type, createNewPushNotificationSaga);
    yield takeLatest(editPushNotificationLoad.type, editPushNotificationSaga);
    yield takeLatest(deletePushNotificationLoad.type, deletePushNotificationSaga);

}
